import GenericDAO from '../generic-dao'

const BASE_URL = '/medclub/especialista'

const _buildPath = (...paths) => `${BASE_URL}/${paths.filter(Boolean).join('/')}/`

// CRUD Principal
const find = (idPFMedica) => GenericDAO.find(`/medclub/especialista/${ idPFMedica }/`)
const findAll = (params) => GenericDAO.find(`/medclub/especialista/`, params, { ignorarEstabelecimento: true })
const save = (dataSend) => GenericDAO.save(`/medclub/especialista/`, dataSend, {formDataIgnore: true})
const remove = (idPFMedica) => GenericDAO.remove(`/medclub/especialista/${ idPFMedica }/`)

// Usuário
const getUsuario = (idPFMedica) => GenericDAO.find(_buildPath(idPFMedica, 'usuario'))
const addUsuario = (idPFMedica, username, estabelecimentos) => GenericDAO.save(_buildPath(idPFMedica, 'usuario'), {'username': username, 'estabelecimentos': estabelecimentos})
const removeUsuario = (idPFMedica) => GenericDAO.remove(_buildPath(idPFMedica, 'usuario'))

// Estabelecimento
const getEstabelecimento = (idPFMedica, params) => GenericDAO.find(_buildPath(idPFMedica, 'estabelecimento'), params, { ignorarEstabelecimento: true })
const addEstabelecimento = (idPFMedica, dataSend) => GenericDAO.sendRequest('POST', _buildPath(idPFMedica, 'estabelecimento'), dataSend)
const editEstabelecimento = (idPFMedica, idEstabelecimento, dataSend) => GenericDAO.sendRequest('PATCH', _buildPath(idPFMedica, 'estabelecimento', idEstabelecimento), dataSend)
const removeEstabelecimento = (idPFMedica, idEstabelecimento) => GenericDAO.remove(_buildPath(idPFMedica, 'estabelecimento', idEstabelecimento))

// Pessoa Jurídica
const getPessoaJuridica = (idPFMedica, params) => GenericDAO.find(_buildPath(idPFMedica, 'pessoa-juridica'), params, { ignorarEstabelecimento: true })
const addPessoaJuridica = (idPFMedica, dataSend) => GenericDAO.sendRequest('POST', _buildPath(idPFMedica, 'pessoa-juridica'), dataSend)
const editPessoaJuridica = (idPFMedica, idPessoaJuridica, dataSend) => GenericDAO.sendRequest('PATCH', _buildPath(idPFMedica, 'pessoa-juridica', idPessoaJuridica), dataSend)
const removePessoaJuridica = (idPFMedica, idPessoaJuridica) => GenericDAO.remove(_buildPath(idPFMedica, 'pessoa-juridica', idPessoaJuridica))

export default {
    find,
    findAll,
    save,
    remove,

    getUsuario,
    addUsuario,
    removeUsuario,

    getEstabelecimento,
    addEstabelecimento,
    editEstabelecimento,
    removeEstabelecimento,

    getPessoaJuridica,
    addPessoaJuridica,
    editPessoaJuridica,
    removePessoaJuridica,
}
